module.exports = __webpack_public_path__ + "img/162014.accc245e.jpg";